<template>
    <b-form-group :invalid-feedback="invalidFeedback" :label="label" :label-for="formControlId">
        <div v-if="selectAllButtons">
            <a href="#" @click.prevent="selectAll">
                alle auswählen
            </a>
            /
            <a href="#" @click.prevent="deselectAll">
                alle abwählen
            </a>
        </div>
        <b-form-checkbox-group
            :id="formControlId"
            v-model="data[property]"
            :buttons="buttons"
            :disabled="isReadOnlyProperty"
            :name="formControlId"
            :options="options"
            :required="isRequiredProperty"
            :stacked="stacked"
            :state="validationState"
            :switches="asSwitch"
            @change="emitChange"/>
    </b-form-group>
</template>

<script>
    import FormGroupMixin from '@components/form/FormGroupMixin';

    export default {
        mixins: [FormGroupMixin],
        props: {
            asSwitch: {
                type: Boolean,
                defaults: false,
            },
            options: {
                type: Array,
                default: () => [],
            },
            buttons: {
                type: Boolean,
                default: false,
            },
            selectAllButtons: {
                type: Boolean,
                default: false,
            },
            stacked: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['change'],
        computed: {
            hasLabelSlot() {
                return !!this.$slots.label;
            },
        },
        methods: {
            emitChange(value) {
                this.$emit('change', value);
            },
            deselectAll() {
                this.data[this.property] = [];
            },
            selectAll() {
                const allSelectedValue = this.options.map(option => option.value);
                this.data[this.property] = allSelectedValue;
            },
        },
    }
</script>
